export const DOMAIN_NAME_OPTIONS = ['api.olgdigital.com']

export const CDN_PREFIX_OPTIONS = ['https://assets-p0.nyc3.cdn.digitaloceanspaces.com']

const DOMAIN_TO_CDN = new Map([
  ['api.olgdigital.com', 'https://assets-p0.nyc3.cdn.digitaloceanspaces.com'],
])

const CDN_TO_DOMAIN = new Map([
  ['https://assets-p0.nyc3.cdn.digitaloceanspaces.com', 'api.olgdigital.com'],
])

/** domainName 变更时联动 cdnPrefix，避免手填不一致。 */
export function syncCdnFromDomain(domainName) {
  return DOMAIN_TO_CDN.get(domainName) || ''
}

/** cdnPrefix 变更时反向联动 domainName。 */
export function syncDomainFromCdn(cdnPrefix) {
  return CDN_TO_DOMAIN.get(cdnPrefix) || ''
}

export const PICTURE_FORMAT_OPTIONS = [
  { label: '通用格式', value: '1' },
  { label: 'WebP', value: '2' },
]

export const PLATFORM_FORM_OPTIONS = [
  { label: 'iOS', value: 'IOS' },
  { label: 'Android', value: 'Android' },
]

export function createEmptyAppRuleForm() {
  return {
    appName: '',
    appKey: '',
    bundleId: '',
    packageList: [],
    icon: '',
    platform: '',
    storeLink: '',
    dynamicTags: [],
    desc: '',
    pictureFormat: '1',
    domainName: '',
    cdnPrefix: '',
  }
}

/** 详情 API 字段映射为表单 model，列表弹窗与路由深链共用。 */
export function mapAppDetailToForm(data) {
  const source = data || {}
  return {
    appName: source.name || '',
    appKey: source.appKey || '',
    bundleId: source.bundleId || '',
    pictureFormat: String(source.pictureFormat == null ? '1' : source.pictureFormat),
    icon: source.icon || '',
    platform: source.system || '',
    domainName: source.domainName || '',
    cdnPrefix: source.cdnPrefix || '',
    storeLink: source.storeUrl || '',
    dynamicTags: source.dataSetWords ? String(source.dataSetWords).split(',') : [],
    desc: source.comment || '',
    packageList: (() => {
      return (source.packageList || []).filter((item) => String(item || '').trim())
    })(),
  }
}

export const APP_FORM_RULES = {
  appName: [{ required: true, message: '应用名不能为空', trigger: 'blur' }],
  appKey: [{ required: true, message: 'appKey 不能为空', trigger: 'blur' }],
  icon: [{ required: true, message: 'Icon 不能为空', trigger: 'change' }],
  platform: [{ required: true, message: '平台必须选一个', trigger: 'change' }],
  domainName: [{ required: true, message: '域名不能为空', trigger: 'change' }],
  cdnPrefix: [{ required: true, message: 'CDN 域名前缀不能为空', trigger: 'change' }],
  dynamicTags: [
    {
      type: 'array',
      required: true,
      message: '数据集不能为空',
      trigger: ['blur', 'change'],
    },
  ],
}
